/**
 * Badge di stato della newsletter (§11.4 / §8.6.1).
 * Mappa lo stato reale del BE su label IT + colore.
 */
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

export const NEWSLETTER_STATUS = {
  DRAFT: { label: 'Bozza', color: '#637381', bg: '#f4f6f8' },
  SCHEDULED: { label: 'Programmata', color: '#1939B7', bg: '#D6E4FF' },
  SENDING: { label: 'In invio', color: '#B76E00', bg: '#FFF1D6' },
  SENT: { label: 'Inviata', color: '#1B806A', bg: '#D8FBDE' },
  STOPPED: { label: 'Interrotta', color: '#B72136', bg: '#FFE7D9' },
  CANCELLED: { label: 'Annullata', color: '#7A0C2E', bg: '#FFE7D9' },
  FAILED: { label: 'Errore', color: '#7A0C2E', bg: '#FFC7CE' },
};

/**
 * @param {{ status: string, size?: 'small'|'medium' }} props
 */
export function StatusBadge({ status, size = 'small' }) {
  const cfg = NEWSLETTER_STATUS[status] ?? { label: status ?? '—', color: '#637381', bg: '#f4f6f8' };

  return (
    <Chip
      size={size}
      label={cfg.label}
      sx={{
        color: cfg.color,
        backgroundColor: cfg.bg,
        fontWeight: 700,
        borderRadius: '6px',
      }}
    />
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default StatusBadge;